import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from './ui/accordion';

export default function FaqAccordion({ items, title = 'Frequently asked questions', subtitle, eyebrow = 'FAQ' }) {
  return (
    <section className="bg-white">
      <div className="container-x section-pad">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="eyebrow mb-4">{eyebrow}</span>
          <h2 className="section-title mt-4">{title}</h2>
          {subtitle && <p className="section-sub mt-3">{subtitle}</p>}
          <div className="divider-svg mt-6" />
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border border-slate-200 rounded-xl bg-white px-5 hover:border-violet-300 transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-violet-700 py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
